import React from 'react';
import {observer} from 'mobx-react';
import store from '../../../../s';
import AbTestStore, {ABTestKeys} from '../../../../../global/store/ab-test-store';
import {Portal} from '../../../../../util';
import {ICheckoutStep, ICheckoutType} from '../../../../i';

interface ICheckoutButtonsProps {
    isMobile: boolean;
    onCheckoutTypeChange: (e: ICheckoutType) => void;
    onTriggerFocus: (id: string) => void;
}

const CheckoutButtons = observer(({isMobile, onCheckoutTypeChange, onTriggerFocus}: ICheckoutButtonsProps) => {
    return (
        <>
            {!isMobile && store.checkout.cstep <= ICheckoutStep.cart && (
                <div className="cs-btn">
                    <div className="hr"></div>
                    <div style={{paddingTop: 0}}>
                        <button
                            type="button"
                            className={`btn-checkout btn-checkout-yellow${Portal?.PortalID === 3 ? ' btn-checkout-yellow-portal3' : ''}${AbTestStore.ABIsVariant(ABTestKeys.ab_checkout_1, 1) ? ' btn-checkout-blue' : ''}`}
                            onClick={() => {
                                onCheckoutTypeChange(ICheckoutType.normal);
                                onTriggerFocus('#checkout-as-guest');
                            }}
                            style={{marginTop: 0}}
                            aria-label="Checkout"
                        >
                            <span className="pad-right">
                                <i
                                    className="fas fa-lock"
                                    aria-hidden={true}
                                ></i>
                            </span>
                            {AbTestStore.ABIsVariant(ABTestKeys.ab_checkout_1, 1) ? 'Secure Checkout' : 'Checkout'}
                        </button>
                    </div>
                    {!store.checkout.isMyFrames && !AbTestStore.ABIsVariant(ABTestKeys.ab_checkout_1, 1) && (
                        <>
                            <div
                                className="text-center"
                                style={{paddingTop: 6}}
                            >
                                <picture>
                                    <source
                                        srcSet={`https://${Portal?.CDNDomain}/images/cached/general/cc3.webp`}
                                        type="image/webp"
                                    />
                                    <img
                                        className="cc3"
                                        src={`https://${Portal?.CDNDomain}/images/cached/general/cc3.png`}
                                        width={216}
                                        height={35}
                                        alt="Most credit cards accepted"
                                    />
                                </picture>
                            </div>
                            <div className="hr"></div>
                            <div
                                className="d-none d-md-block"
                                style={{marginBottom: 10}}
                            >
                                - or -
                            </div>
                            <div>
                                <button
                                    type="button"
                                    className="btn-checkout btn-checkout-white"
                                    aria-label="Checkout with PayPal"
                                    onClick={() => onCheckoutTypeChange(ICheckoutType.paypal_express)}
                                >
                                    <picture>
                                        <source
                                            srcSet={`https://${Portal?.CDNDomain}/images/cached/general/pp_logo_h_100x26.webp`}
                                            type="image/webp"
                                        />
                                        <img
                                            src={`https://${Portal?.CDNDomain}/images/cached/general/pp_logo_h_100x26.png`}
                                            width={100}
                                            height={26}
                                            alt="Checkout with PayPal "
                                        />
                                    </picture>
                                </button>
                            </div>
                        </>
                    )}

                    {AbTestStore.ABIsVariant(ABTestKeys.ab_checkout_1, 1) && (
                        <button
                            type="button"
                            className={`btn-checkout btn-checkout-yellow${Portal?.PortalID === 3 ? ' btn-checkout-yellow-portal3' : ''}`}
                            style={{textTransform: 'uppercase', marginTop: 10}}
                            aria-label="Learn about Pay in installments with PayPal"
                            onClick={() => window.open('https://www.paypal.com/us/digital-wallet/ways-to-pay/buy-now-pay-later')}
                        >
                            Pay in installments with
                            <picture style={{marginLeft: 10, marginTop: -5}}>
                                <source
                                    srcSet={`https://${Portal?.CDNDomain}/images/cached/general/pp_logo_h_100x26.webp`}
                                    type="image/webp"
                                />
                                <img
                                    src={`https://${Portal?.CDNDomain}/images/cached/general/pp_logo_h_100x26.png`}
                                    width={70}
                                    height="auto"
                                    alt="Pay in installments with"
                                />
                            </picture>
                        </button>
                    )}

                    {!store.checkout.isMyFrames && store.payment_allow_apple && (
                        <div style={{paddingTop: 12}}>
                            <button
                                type="button"
                                className="btn-checkout btn-checkout-white"
                                onClick={() => onCheckoutTypeChange(ICheckoutType.normal)}
                                aria-label="Checkout with Apple Pay"
                            >
                                <i
                                    className="fab fa-apple-pay"
                                    aria-hidden={true}
                                ></i>
                            </button>
                        </div>
                    )}

                    {!store.checkout.isMyFrames && store.payment_allow_google && (
                        <div style={{paddingTop: 12}}>
                            <button
                                type="button"
                                className="btn-checkout btn-checkout-white"
                                onClick={() => onCheckoutTypeChange(ICheckoutType.normal)}
                                aria-label="Checkout with Google Pay"
                            >
                                <picture>
                                    <source
                                        srcSet={`https://${Portal?.CDNDomain}/images/cached/general/gpay.webp`}
                                        type="image/webp"
                                    />
                                    <img
                                        style={{maxHeight: 20, width: 'auto'}}
                                        src={`https://${Portal?.CDNDomain}/images/cached/general/gpay.png`}
                                        width={50}
                                        height={26}
                                        aria-hidden={true}
                                        alt=""
                                    />
                                </picture>
                            </button>
                        </div>
                    )}

                    {!store.checkout.isMyFrames && store.payment_allow_venmo && (
                        <div style={{paddingTop: 12}}>
                            <button
                                type="button"
                                className="btn-checkout btn-checkout-white"
                                onClick={() => onCheckoutTypeChange(ICheckoutType.normal)}
                                aria-label="Checkout with Venmo"
                            >
                                <picture>
                                    <source
                                        srcSet={`https://${Portal?.CDNDomain}/images/cached/general/venmo_payment.webp`}
                                        type="image/webp"
                                    />
                                    <img
                                        style={{maxHeight: 20, width: 'auto'}}
                                        src={`https://${Portal?.CDNDomain}/images/cached/general/venmo_payment.png`}
                                        width={131}
                                        height={26}
                                        aria-hidden={true}
                                        alt=""
                                    />
                                </picture>
                            </button>
                        </div>
                    )}
                </div>
            )}

            {isMobile && store.checkout.cstep <= ICheckoutStep.cart && (
                <div
                    className="cs-btn"
                    style={{marginBottom: 24}}
                >
                    <div className="hr"></div>
                    <div style={{paddingTop: 0}}>
                        <button
                            type="button"
                            className={`btn-checkout btn-checkout-yellow${Portal?.PortalID === 3 ? ' btn-checkout-yellow-portal3' : ''}${AbTestStore.ABIsVariant(ABTestKeys.ab_checkout_1, 1) ? ' btn-checkout-blue' : ''}`}
                            onClick={() => onCheckoutTypeChange(ICheckoutType.normal)}
                            style={{marginTop: 6}}
                            aria-label="Checkout"
                        >
                            <span className="pad-right">
                                <i
                                    className="fas fa-lock"
                                    aria-hidden={true}
                                ></i>
                            </span>
                            Checkout
                        </button>
                        {!store.checkout.myframes_isDropShip && !store.checkout.isMyFrames && (
                            <div
                                className="text-center"
                                style={{marginTop: 6}}
                            >
                                <picture>
                                    <source
                                        srcSet={`https://${Portal?.CDNDomain}/images/cached/general/cc3.webp`}
                                        type="image/webp"
                                    />
                                    <img
                                        className="checkout-cc-mobile cc3"
                                        src={`https://${Portal?.CDNDomain}/images/cached/general/cc3.png`}
                                        width={216}
                                        height={35}
                                        style={{paddingLeft: 12}}
                                        alt="Most credit cards accepted"
                                    />
                                </picture>
                            </div>
                        )}
                    </div>
                    {!store.checkout.isMyFrames && <div style={{marginTop: 6}}>- Or Check Out With -</div>}

                    {!store.checkout.isMyFrames && (
                        <div style={{paddingTop: 6}}>
                            <button
                                type="button"
                                className="btn-checkout btn-checkout-white"
                                onClick={() => onCheckoutTypeChange(ICheckoutType.paypal_express)}
                            >
                                <picture>
                                    <source
                                        srcSet={`https://${Portal?.CDNDomain}/images/cached/general/pp_logo_h_100x26.webp`}
                                        type="image/webp"
                                    />
                                    <img
                                        src={`https://${Portal?.CDNDomain}/images/cached/general/pp_logo_h_100x26.png`}
                                        width={100}
                                        height={26}
                                        alt="Checkout with PayPal "
                                    />
                                </picture>
                            </button>
                        </div>
                    )}

                    {!store.checkout.isMyFrames && store.payment_allow_apple && (
                        <div style={{paddingTop: 6}}>
                            <button
                                type="button"
                                className="btn-checkout btn-checkout-white"
                                onClick={() => onCheckoutTypeChange(ICheckoutType.normal)}
                                aria-label="Checkout with Apple Pay"
                            >
                                <i
                                    className="fab fa-apple-pay"
                                    aria-hidden={true}
                                ></i>
                            </button>
                        </div>
                    )}

                    {!store.checkout.isMyFrames && store.payment_allow_google && (
                        <div style={{paddingTop: 6}}>
                            <button
                                type="button"
                                className="btn-checkout btn-checkout-white"
                                onClick={() => onCheckoutTypeChange(ICheckoutType.normal)}
                                aria-label="Checkout with Google Pay"
                            >
                                <picture>
                                    <source
                                        srcSet={`https://${Portal?.CDNDomain}/images/cached/general/gpay.webp`}
                                        type="image/webp"
                                    />
                                    <img
                                        style={{maxHeight: 20, width: 'auto'}}
                                        src={`https://${Portal?.CDNDomain}/images/cached/general/gpay.png`}
                                        width={50}
                                        height={26}
                                        aria-hidden={true}
                                        alt=""
                                    />
                                </picture>
                            </button>
                        </div>
                    )}

                    {!store.checkout.isMyFrames && store.payment_allow_venmo && (
                        <div style={{paddingTop: 6}}>
                            <button
                                type="button"
                                className="btn-checkout btn-checkout-white"
                                onClick={() => onCheckoutTypeChange(ICheckoutType.normal)}
                                aria-label="Checkout with Venmo"
                            >
                                <picture>
                                    <source
                                        srcSet={`https://${Portal?.CDNDomain}/images/cached/general/venmo_payment.webp`}
                                        type="image/webp"
                                    />
                                    <img
                                        style={{maxHeight: 20, width: 'auto'}}
                                        src={`https://${Portal?.CDNDomain}/images/cached/general/venmo_payment.png`}
                                        width={131}
                                        height={26}
                                        aria-hidden={true}
                                        alt=""
                                    />
                                </picture>
                            </button>
                        </div>
                    )}
                </div>
            )}
        </>
    );
});

export default CheckoutButtons;
